import { render, staticRenderFns } from "./DataAddRemoveBtn.vue?vue&type=template&id=60fa4c95&"
import script from "./DataAddRemoveBtn.vue?vue&type=script&lang=js&"
export * from "./DataAddRemoveBtn.vue?vue&type=script&lang=js&"
import style0 from "./DataAddRemoveBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports